<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  weeklyCount: {
    type: Number,
    default: 0,
  },
  weeklyLimit: {
    type: Number,
    default: 0,
  },
  limitReached: {
    type: Boolean,
    default: false,
  },
  hasRevealedContact: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['open']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Proprietário" density="cozy">
    <div class="flex items-start justify-between gap-3">
      <div>
        <p class="text-[13px] font-semibold text-lais-text">
          {{ weeklyCount }} de {{ weeklyLimit }} revelações
        </p>
        <p class="mt-1 text-[12px] leading-relaxed text-lais-text-muted">
          Limite semanal por atendente com auditoria LGPD.
        </p>
      </div>
      <span
        class="grid size-9 shrink-0 place-items-center rounded-full bg-lais-primary-50 text-lais-primary"
      >
        <span class="i-lucide-shield-check size-4" aria-hidden="true" />
      </span>
    </div>

    <p
      v-if="limitReached"
      class="mt-4 rounded-lais-sm border border-amber-200 bg-amber-50 px-3 py-2 text-[12px] leading-relaxed text-amber-800"
    >
      Limite semanal atingido. Os contatos voltam a ficar disponíveis no próximo
      ciclo semanal.
    </p>

    <LaisPrimaryButton
      class="mt-4 w-full"
      :icon="hasRevealedContact ? 'i-lucide-user-check' : 'i-lucide-eye'"
      :disabled="loading"
      :is-loading="loading"
      @click="emit('open')"
    >
      {{ hasRevealedContact ? 'Ver contato revelado' : 'Solicitar contato' }}
    </LaisPrimaryButton>
  </LaisCard>
</template>
